import { stringify } from "query-string"

import { farasod } from "./api"

const endpoint = "/campaign"

export const getCampaigns = async (queries) => {
  const query =
    stringify(queries,
      {
        skipEmptyString: true,
        skipNull: true
      }
    )

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const createCampaign = async (data) => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const editCampaign = async (campaignId, data) => {
  const response = await farasod.patch(`${endpoint}/${campaignId}`, data)

  return response.data
}

export const deleteCampaign = async (campaignId) => {
  const response = await farasod.delete(`${endpoint}/${campaignId}`)

  return response.data
}